import { useForm } from "react-hook-form";
import useCreateCourse from "../hooks/useCreateCourse";
import { FormControlLabel, Switch } from "@mui/material";
import { useState } from "react";
import Input from "../../../../components/input/Input";
import Select from "../../../../components/select/Select";
import Button from "../../../../components/Button";
import { useSchoolLevelOptions } from "../../../../hooks/useSchoolLevelOptions";


function CreateForm({ onCloseModal }) {
    const [isVisibil, setIsVisibil] = useState(true);
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        watch,
        setValue,
        getValues
    } = useForm();

    const { createCourse, isCreating, error: ApiError } = useCreateCourse();
    const selectedSchoolLevel = getValues("school_level");
    const { isSchoolLevelOptionsLoading, schoolLevelOptions, gradesOptions } = useSchoolLevelOptions(selectedSchoolLevel);

    function onSubmit({ name, brief, school_level, grade, visibility = isVisibil ? 1 : 0, type = 1 }) {
        createCourse(
            { name, brief, grade, school_level, visibility, type },
            { onSuccess: () => { reset(); onCloseModal?.(); } }
        );
    }

    return (
        <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex flex-col items-center justify-center w-full gap-3"
        >
            <h3 className="py-5 text-xl text-blue-color-primary">
                إضافة فصل دراسي جديد
            </h3>

            <FormControlLabel
                control={
                    <Switch
                        checked={isVisibil}
                        onChange={(e) => setIsVisibil(e.target.checked)}
                        inputProps={{ "aria-label": "controlled" }}
                        color="primary"
                    />
                }
                label="مفعل"
            />

            <div className="w-full space-y-2">
                <Input
                    label="أسم الفصل الدراسي"
                    name="name"
                    register={register("name", {
                        maxLength: { value: 70, message: "أسم الفصل الدراسي يجب ان لا يزيد عن 70 حرف" },
                        required: "يرجا إدخال أسم الفصل الدراسي",
                    })}
                    error={errors?.name?.message || ApiError?.response?.data?.errors?.name?.[0]}
                    type="text"
                    size="fullWidth"
                    disabled={isCreating}
                />

                <Input
                    label="الوصف"
                    name="brief"
                    register={register("brief", {
                        maxLength: { value: 250, message: "الوصف يجب ان لا يزيد عن 250 حرف" },
                        required: "يرجا إدخال وصف الفصل الدراسي",
                    })}
                    error={errors?.brief?.message || ApiError?.response?.data?.errors?.brief?.[0]}
                    type="text"
                    disabled={isCreating}
                />
            </div>

            <Select
                name="school_level"
                label="المستوى الدراسي*"
                disabled={isCreating}
                setValue={setValue}
                watch={watch}
                register={register("school_level", {
                    required: "الرجاء تحديد المستوى الدراسي",
                })}
                error={
                    errors?.school_level?.message ||
                    ApiError?.response?.data?.errors?.school_level?.[0]
                }
                isOptionsLoading={isSchoolLevelOptionsLoading}
                options={schoolLevelOptions}
            />

            <Select
                name="grade"
                label="الصف*"
                disabled={isCreating || !selectedSchoolLevel}
                setValue={setValue}
                watch={watch}
                register={register("grade", {
                    required: "الرجاء تحديد السنة الدراسية",
                })}
                error={
                    errors?.grade?.message ||
                    ApiError?.response?.data?.errors?.grade?.[0]
                }
                isOptionsLoading={isSchoolLevelOptionsLoading}
                options={gradesOptions}
            />

            <Select
                name="type"
                label="نوع الفصل الدراسي*"
                disabled={isCreating}
                setValue={setValue}
                watch={watch}
                register={register("type", {
                    required: "الرجاء تحديد نوع الفصل الدراسي",
                })}
                error={
                    errors?.type?.message ||
                    ApiError?.response?.data?.errors?.type?.[0]
                }
                options={[
                    { value: "1", text: "اونلاين" },
                    { value: "2", text: "سنتر" },
                ]}
            />

            <div className="w-full pt-3">
                <Button type="primary" className="w-full leading-8" disabled={isCreating}>
                    إضافة فصل دراسي
                </Button>
            </div>
        </form>
    );
}

export default CreateForm;
